/* eslint-disable vars-on-top */
var debounce = require('lodash/debounce');

var DISABLED_BTN_CLASS = 'disabled-btn';
var HIDE_CLASS = 'd-none';
var SHOW_CLASS = 'd-block';
var ADD_CART_BUTTON_CLASS = 'button.add-to-cart, button.add-to-cart-global, .btn-update-wishlist-product, .update-cart-product-global';

function updateQuantityButtonsAndError($productContainer, hasErrors, $addToCartContainer, $globalAddToCart) {
  var $quantityInput = $productContainer.find('.quantity-input, .quantity-input-widget');
  var quantity = parseInt($quantityInput.val(), 10);
  var maxQuantity = parseInt($quantityInput.data('max'), 10);

  var $increaseButton = $productContainer.find('.quantity-increase, .quantity-widget-increase');
  var $decreaseButton = $productContainer.find('.quantity-decrease, .quantity-widget-decrease');
  var $errorContainer = $productContainer.find('.quantity-error');
  var $warningContainer = $productContainer.find('.quantity-warning');


  if (quantity <= 1) {
    $decreaseButton.addClass(DISABLED_BTN_CLASS).attr('disabled', true);
  } else {
    $decreaseButton.removeClass(DISABLED_BTN_CLASS).attr('disabled', false);
  }

  if (quantity === maxQuantity) {
    $increaseButton.addClass(DISABLED_BTN_CLASS).attr('disabled', true);
    $errorContainer.removeClass(SHOW_CLASS).addClass(HIDE_CLASS);
    $warningContainer.removeClass(HIDE_CLASS).addClass(SHOW_CLASS);
  }

  if (quantity > maxQuantity) {
    $increaseButton.addClass(DISABLED_BTN_CLASS).attr('disabled', true);
    $errorContainer.removeClass(HIDE_CLASS).addClass(SHOW_CLASS);
    $warningContainer.removeClass(SHOW_CLASS).addClass(HIDE_CLASS);
    if ($addToCartContainer) {
      $addToCartContainer.find(ADD_CART_BUTTON_CLASS).attr('disabled', true);
    } else {
      $(ADD_CART_BUTTON_CLASS).attr('disabled', true);
    }
  } else if (quantity < maxQuantity) {
    $increaseButton.removeClass(DISABLED_BTN_CLASS).attr('disabled', false);
    $errorContainer.removeClass(SHOW_CLASS).addClass(HIDE_CLASS);
    $warningContainer.removeClass(SHOW_CLASS).addClass(HIDE_CLASS);
  }

  if ($addToCartContainer) {
    var errorExists = hasErrors();
    if (errorExists) {
      $addToCartContainer.find(ADD_CART_BUTTON_CLASS).attr('disabled', true);
      if ($globalAddToCart) { $globalAddToCart.addClass('disabled'); }
    } else {
      $addToCartContainer.find(ADD_CART_BUTTON_CLASS).attr('disabled', false);
      if ($globalAddToCart) { $globalAddToCart.removeClass('disabled'); }
    }
  }

  if (!$addToCartContainer) {
    var errorExist = hasErrors();
    if (errorExist) {
      $(ADD_CART_BUTTON_CLASS).attr('disabled', true);
      if ($globalAddToCart) { $globalAddToCart.addClass('disabled'); }
    } else {
      $(ADD_CART_BUTTON_CLASS).attr('disabled', false);
      if ($globalAddToCart) { $globalAddToCart.removeClass('disabled'); }
    }
  }
}

function getDebouncedFn(fn) {
  return debounce(function (url, $productContainer) {
    fn(url, $productContainer);
  }, 300);
}

function getCurrentQuantity(context) {
  var $quantityInput = $(context);
  return parseInt($quantityInput.val(), 10);
}

function getMaxQuantity(context) {
  var $quantityInput = $(context);
  return parseInt($quantityInput.data('max'), 10);
}

function getStep(context) {
  var $quantityInput = $(context);
  return parseInt($quantityInput.data('step'), 10);
}

function setQuantiy(context, value) {
  var $quantityInput = $(context);
  $quantityInput.val(value);
}

function preventInvalidInput(e) {
  if (e.key === ',' || e.key === '.') {
    e.preventDefault();
  }
}

function resetOnBlur($this) {
  if ($this.val() === '' || $this.val() < 1) {
    $this.val(1);
  }
}



/**
 * QUANTITY SELECTOR - CUSTOM: Updates announcement
 * =================================================
 */

// QUANTITY ANNOUNCEMENT: making announcement function available as child of window object
SiteAccessibility.customQuantityAnnouncement = function (inputEl, announcementEl) {
    const $input = $(inputEl);
    const $qtyUpdates = $(announcementEl);

    if (!$input.length || !$qtyUpdates.length) return;

    const maxLimit = parseInt($input.attr("data-max"), 10) || Infinity;
    const quantity = parseInt($input.val(), 10) || 0;

    const msgPart1 = window.quantityMsgPart1 || "You have reached";
    const msgPart2 = window.quantityMsgPart2 || "the maximum limit of";
    const msgPart3 = window.quantityMsgPart3 || maxLimit;
    const warningMsg = `${msgPart1} ${msgPart2} ${msgPart3}`.trim();

    let message = `Product Quantity: ${quantity}`;

    if (quantity > maxLimit) {
        message = warningMsg;
        // Allow decrement even if max exceeded, don't disable fully
        $input.attr("aria-invalid", "true");
    } else {
        $input.removeAttr("aria-invalid");
    }

    // Update live region (avoid forcing focus)
    $qtyUpdates
        .attr({
            role: "status",
            "aria-live": "polite",
            "aria-atomic": "true"
        })
        .addClass("sr-only")
        .empty();

    requestAnimationFrame(() => {
        $qtyUpdates.text(message).attr("title", message);
    });
};

// Trigger helper
function triggerQuantityAnnouncement($wrapper) {
    const $input = $wrapper.find('.quantity-input, .quantity-input-widget').first();
    const $announcement = $wrapper.find('.quantity-announcement').first();
    
    if (typeof SiteAccessibility.customQuantityAnnouncement === 'function') {
        SiteAccessibility.customQuantityAnnouncement($input, $announcement);
    }
}

/**
 * Unified Quantity Change Observer
 * Handles quantity updates via click, change, or blur events.
 * Works with both event delegation and direct invocation.
 *
 * @function productQuantityObserver
 * @param {Event} event - Triggered DOM event.
 */
SiteAccessibility.productQuantityObserver = function (event) {
    const $wrapper = $(this);
    const $target = $(event.target);

    const clickSelectors = '.quantity-increase, .quantity-decrease, .quantity-widget-increase, .quantity-widget-decrease';
    const inputSelectors = '.quantity-input, .quantity-input-widget';

    const isClickEvent = event.type === 'click' && $target.is(clickSelectors);
    const isInputEvent = (event.type === 'change' || event.type === 'blur') && $target.is(inputSelectors);

    if (isClickEvent) {
        // Prevent rapid multiple clicks
        if ($target.data('lock')) {
            event.preventDefault();
            return false; // stop if locked
        }
        $target.data('lock', true);
        setTimeout(() => $target.removeData('lock'), 300); // unlock after 300ms
    }

    if (isClickEvent || isInputEvent) {
        triggerQuantityAnnouncement($wrapper);
    }
};

// Event delegation binding
$(document).on(
    'click change blur',
    '.quantity-wrapper, .quantity-widget-wrapper',
    SiteAccessibility.productQuantityObserver
);





module.exports = {
  updateQuantityButtonsAndError: updateQuantityButtonsAndError,
  getDebouncedFn: getDebouncedFn,
  getCurrentQuantity: getCurrentQuantity,
  getMaxQuantity: getMaxQuantity,
  getStep: getStep,
  setQuantiy: setQuantiy,
  preventInvalidInput: preventInvalidInput,
  resetOnBlur: resetOnBlur
};
